import type { Database } from 'sql.js';
import { queryOne } from '@core/infrastructure/driven/sqljs/sqljsSqlitePrimitives.ts';
import { purgeParticipantesYAcudientes } from './savePuntoEntrega.ts';

function rollbackQuiet(db: Database): void {
  try {
    db.run('ROLLBACK');
  } catch {
    /* ignore */
  }
}

function sqliteTableExists(db: Database, tableName: string): boolean {
  return (
    queryOne(db, `SELECT 1 AS ok FROM sqlite_master WHERE type='table' AND name=? LIMIT 1`, [tableName]) != null
  );
}

/** Removes a delivery point only if `offline_uploaded_at` is set (successful prior sync). */
export function deleteUploadedPuntoEntregaInDb(db: Database, schedulePersist: () => void, puntoId: number): void {
  const row = queryOne(db, 'SELECT id, offline_uploaded_at FROM punto_entrega WHERE id = ? LIMIT 1', [puntoId]);
  if (!row) {
    throw new Error('El punto de entrega no existe.');
  }
  const uploadedRaw = row.offline_uploaded_at ?? row.OFFLINE_UPLOADED_AT;
  const uploadedStr = uploadedRaw != null && uploadedRaw !== '' ? String(uploadedRaw).trim() : '';
  if (uploadedStr.length === 0) {
    throw new Error('Solo puede eliminar registros ya enviados al servidor.');
  }

  db.run('BEGIN IMMEDIATE');
  try {
    if (sqliteTableExists(db, 'participante_entrega_archivos')) {
      db.run(
        `DELETE FROM participante_entrega_archivos WHERE punto_entrega_participante_id IN (
           SELECT id FROM punto_entrega_participante WHERE punto_entrega_id = ?
         )`,
        [puntoId],
      );
    }
    purgeParticipantesYAcudientes(db, puntoId);
    if (sqliteTableExists(db, 'punto_entrega_anexos')) {
      db.run('DELETE FROM punto_entrega_anexos WHERE punto_entrega_id = ?', [puntoId]);
    }
    db.run('DELETE FROM punto_entrega WHERE id = ?', [puntoId]);
    db.run('COMMIT');
    schedulePersist();
  } catch (e) {
    rollbackQuiet(db);
    throw e;
  }
}
